import * as React from 'react';

import * as main from '../styles/main.module.scss';
import * as courseSummary from '../styles/courseSummary.module.scss';

export const CourseSummary = () => {
  return (
    <section className={courseSummary.courseSummary}>
      <div className={'container'}>
        <div className={courseSummary.courseSummary__wrapper}>
          <p className={`${main.title} ${courseSummary.courseSummary__title}`}>На курсе мы вместе будем:</p>
          <ul className={`row ${courseSummary.courseSummary__list}`}>
            <li
              className={`col-lg-4 ${courseSummary.courseSummary__listItem} ${courseSummary.courseSummary__listItemOne}`}
            >
              <mark className={courseSummary.courseSummary__mark}>составлять майнд-карты</mark>
              <br />
              по правилам грамматики, которые ребёнок сможет применять в изучении других предметов
            </li>
            <li
              className={`col-lg-4 ${courseSummary.courseSummary__listItem} ${courseSummary.courseSummary__listItemTwo}`}
            >
              <mark className={courseSummary.courseSummary__mark}>выполнять задания</mark>
              <br />
              на тренировку памяти
            </li>
            <li
              className={`col-lg-4 ${courseSummary.courseSummary__listItem} ${courseSummary.courseSummary__listItemThree}`}
            >
              <mark className={courseSummary.courseSummary__mark}>учить 11 грамматических правил</mark>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};
